import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Curriculum() {
  const modules = [{
    num: 1,
    title: 'Tu Mentalidad de Mamá CEO',
    desc: 'Rompe el miedo a la tecnología y entiende por qué tu celular es una fábrica de dinero si sabes qué botones tocar.'
  }, {
    num: 2,
    title: 'El Detector de Dinero IA',
    desc: 'Deja que la IA analice el mercado de USA por ti y te diga exactamente qué PDF quiere comprar la gente ahora mismo. Cero adivinanzas.'
  }, {
    num: 3,
    title: 'Fábrica de Productos Express',
    desc: 'Mira cómo la IA escribe capítulos completos y estructura tu oferta en menos de 60 minutos. Tú solo supervisas.'
  }, {
    num: 4,
    title: 'Diseño Pro con Gamma',
    desc: 'Convierte textos simples en un producto digital premium y hermoso usando solo tu celular. Sin saber de diseño.'
  }, {
    num: 5,
    title: 'El Sistema de Ventas Silenciosas',
    desc: 'Cómo usar Instagram y WhatsApp para que la gente te escriba "Info" sin que tú tengas que perseguir a nadie.'
  }];
  return <section className="bg-white py-24 px-4 pt-[50px] pb-[50px]" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-50">
          <span className="text-primary font-bold uppercase tracking-wider text-sm" data-id="element-51">
            Qué Incluye
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline mt-2" data-id="element-52">
            De la Idea a la Venta
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-53">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-light rounded-[20px] border border-border p-6 md:p-8 hover:shadow-xl transition-shadow hover:border-primary/30" data-id="element-54">
              <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-55">
                <div className="flex-shrink-0 w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-xl border border-primary/20" data-id="element-56">
                  {mod.num}
                </div>
                <div data-id="element-57">
                  <h3 className="text-2xl text-dark font-display font-bold mb-3" data-id="element-58">
                    Capítulo {mod.num}: {mod.title}
                  </h3>
                  <p className="text-body leading-relaxed text-lg" data-id="element-59">
                    {mod.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}